import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Recurring.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Recurring billing</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Set it once.<br /><span className={styles.hl}>Get paid on repeat.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Put retainers, subscriptions, and memberships on autopilot. Pick the cadence, send to one client or many, and let the invoices go out — and the payments come in — automatically.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Flexible cadence</span>
          <span><CheckSmall />Free to start</span>
          <span><CheckSmall />Pause anytime</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#161614" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-3-6.7M21 4v4h-4" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Auto-sent</div><div className={styles.fcVal}>#1043</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#2EB66E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v13m0 0l-4-4m4 4l4-4M5 21h14" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Collected</div><div className={styles.fcVal}>$2,500.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.invTop}>
            <div><div className={styles.invLab}>RECURRING</div><div className={styles.invNum}>Monthly retainer · Acme</div></div>
            <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Active</span>
          </div>
          <div className={styles.invRow}><span>Amount</span><span className={styles.mono}>$2,500.00</span></div>
          <div className={styles.invRow}><span>Cadence</span><span className={styles.mono}>Monthly · 1st</span></div>
          <div className={styles.invRow}><span>Next invoice</span><span className={styles.mono}>May 1</span></div>
          <div className={styles.invPaynow}>Auto-sends on schedule</div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
